'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _useUniqueId = require('react-utils/hooks/useUniqueId');

var _useUniqueId2 = _interopRequireDefault(_useUniqueId);

var _memoize = require('react-utils/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _FieldsetContext = require('../context/FieldsetContext');

var _Checkable = require('../decorators/Checkable');

var _Checkable2 = _interopRequireDefault(_Checkable);

var _UICheckmark = require('../icon/icons/UICheckmark');

var _UICheckmark2 = _interopRequireDefault(_UICheckmark);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _TabIndex = require('../utils/TabIndex');

var _CheckboxConstants = require('./CheckboxConstants');

var _ToggleInputWrapper = require('./internal/ToggleInputWrapper');

var _ToggleInputWrapper2 = _interopRequireDefault(_ToggleInputWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var renderCheckmark = (0, _memoize2.default)(function () {
  return _react2.default.createElement(_UICheckmark2.default, { className: 'private-checkbox__icon__inner' });
});

var renderDash = (0, _memoize2.default)(function () {
  return _react2.default.createElement(
    'svg',
    {
      role: 'presentation',
      viewBox: '0 0 14 14',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement('path', {
      className: 'private-checkbox__icon__inner',
      d: 'M 2 6 L12 6 L12 9 L2 9 L2 6 z'
    })
  );
});

var renderIndicator = (0, _memoize2.default)(function (color) {
  return _react2.default.createElement(
    'span',
    {
      className: 'private-checkbox__indicator',
      'data-indicator': true,
      style: { color: color }
    },
    _react2.default.createElement(
      'span',
      { className: 'private-checkbox__icon private-checkbox__check' },
      renderCheckmark()
    ),
    _react2.default.createElement(
      'span',
      { className: 'private-checkbox__icon private-checkbox__dash' },
      renderDash()
    )
  );
});

var UICheckbox = (0, _react.forwardRef)(function (props, ref) {
  var ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      checked = props.checked,
      children = props.children,
      className = props.className,
      color = props.color,
      description = props.description,
      disabled = props.disabled,
      id = props.id,
      indeterminate = props.indeterminate,
      innerPadding = props.innerPadding,
      name = props.name,
      _onChange = props.onChange,
      readOnly = props.readOnly,
      size = props.size,
      tabIndex = props.tabIndex,
      value = props.value,
      rest = _objectWithoutProperties(props, ['aria-label', 'aria-labelledby', 'checked', 'children', 'className', 'color', 'description', 'disabled', 'id', 'indeterminate', 'innerPadding', 'name', 'onChange', 'readOnly', 'size', 'tabIndex', 'value']);

  var _useContext = (0, _react.useContext)(_FieldsetContext.FieldsetContext),
      fieldSize = _useContext.size,
      fieldDisabled = _useContext.disabled;

  if (process.env.NODE_ENV !== 'production') {
    if (children == null && !ariaLabel && !ariaLabelledBy) {
      _devLogger2.default.warn({
        message: "UICheckbox: `aria-label` or `aria-labelledby` is required if you don't define `children`.",
        key: 'UICheckbox: no label'
      });
    }

    if (children && (ariaLabel || ariaLabelledBy)) {
      _devLogger2.default.warn({
        message: 'UICheckbox: `aria-label`/`aria-labelledby` should not be used with `children`.',
        key: 'UICheckbox: too many labels'
      });
    }
  }

  var descriptionId = (0, _useUniqueId2.default)('checkbox-');
  var computedDisabled = disabled || fieldDisabled;
  var computedSize = size || fieldSize;

  return _react2.default.createElement(
    _ToggleInputWrapper2.default,
    _extends({}, rest, {
      checked: checked,
      className: (0, _classnames2.default)(className, 'private-checkbox', _CheckboxConstants.PADDING_OPTIONS[innerPadding], {
        'private-checkbox--unlabeled': children == null
      }),
      description: description,
      descriptionId: descriptionId,
      disabled: computedDisabled,
      input: _react2.default.createElement('input', {
        'aria-describedby': description ? descriptionId : null,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledBy,
        checked: checked,
        className: (0, _classnames2.default)('private-checkbox__input sr-only', {
          indeterminate: indeterminate
        }),
        disabled: computedDisabled,
        id: id,
        name: name,
        onChange: function onChange(evt) {
          if (disabled || readOnly) {
            evt.preventDefault();
            return;
          }
          _onChange(evt);
        },
        readOnly: readOnly,
        tabIndex: (0, _TabIndex.getTabIndex)(readOnly || disabled, tabIndex),
        type: 'checkbox',
        value: value
      }),
      indicator: renderIndicator(color),
      onChange: _onChange,
      readOnly: readOnly,
      ref: ref,
      size: computedSize
    }),
    children
  );
});

UICheckbox.propTypes = {
  alignment: _propTypes2.default.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
  'aria-label': _propTypes2.default.string,
  'aria-labelledby': _propTypes2.default.string,
  checked: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  color: _propTypes2.default.string,
  description: _propTypes2.default.node,
  descriptionLayout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  disabled: _propTypes2.default.bool,
  indeterminate: _propTypes2.default.bool,
  inline: _propTypes2.default.bool,
  innerPadding: _propTypes2.default.oneOf(Object.keys(_CheckboxConstants.PADDING_OPTIONS)).isRequired,
  labelClassName: _propTypes2.default.string,
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  readOnly: _propTypes2.default.bool,
  size: _propTypes2.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm']), _propTypes2.default.oneOf(['default'])]),
  value: _propTypes2.default.any
};

UICheckbox.defaultProps = {
  alignment: 'start',
  checked: false,
  descriptionLayout: 'vertical',
  innerPadding: 'default'
};

UICheckbox.displayName = 'UICheckbox';

exports.default = (0, _Checkable2.default)(UICheckbox);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/input/UICheckbox.js
// module id = 576
// module chunks = 177